import { render, staticRenderFns } from "./TransporterFields.vue?vue&type=template&id=0c34cef7"
import script from "./TransporterFields.vue?vue&type=script&lang=js"
export * from "./TransporterFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports